import type { DataApi } from './types';
import { FirebaseApi } from './FirebaseApi';
import app from '../services/firebase'; // This initializes the app

let apiInstance: DataApi;

if (app) {
  apiInstance = new FirebaseApi(app);
} else {
  // If app fails to init, we are in a broken state.
  // The global ConfigCheck component will warn the user.
  // We throw an error if the API is used before initialization.
  apiInstance = new Proxy({} as DataApi, {
    get() {
      throw new Error("Firebase app not initialized. Check your .env configuration.");
    }
  });
}

export const api = apiInstance;
